"use strict";
exports.__esModule = true;
exports.OrganisationBrandingDocument = void 0;
var OrganisationBrandingDocument = /** @class */ (function () {
    function OrganisationBrandingDocument(id, logo, icon, //favicon
    brand_colour, accent_colour, created_at, updated_at, created_by, updated_by) {
        this.id = id;
        this.logo = logo;
        this.icon = icon;
        this.brand_colour = brand_colour;
        this.accent_colour = accent_colour;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.created_by = created_by;
        this.updated_by = updated_by;
    }
    OrganisationBrandingDocument.fromJSON = function (json) {
        var organisation = new OrganisationBrandingDocument('', '', '', '', '', 0, 0, '', '');
        if (json) {
            organisation.id = json.id ? json.id : '';
            organisation.logo = json.logo ? json.logo : '';
            organisation.icon = json.icon ? json.icon : '';
            organisation.brand_colour = json.brand_colour ? json.brand_colour : '';
            organisation.accent_colour = json.accent_colour ? json.accent_colour : '';
            organisation.created_at = json.created_at ? json.created_at : 0;
            organisation.updated_at = json.updated_at ? json.updated_at : 0;
            organisation.created_by = json.created_by ? json.created_by : '';
            organisation.updated_by = json.updated_by ? json.updated_by : '';
        }
        return organisation;
    };
    return OrganisationBrandingDocument;
}());
exports.OrganisationBrandingDocument = OrganisationBrandingDocument;
